<template>
  <el-row>
    <el-col :span="24">
      <el-card v-loading="loading">
        <div slot="header" class="flex-space-between">
          <span class="title">Home</span>
          <Filters />
        </div>
        <Table />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Filters from '../components/Filters'
import Table from '../components/Table'
import { mapState } from 'vuex'

export default {
  components: {
    Filters,
    Table
  },

  computed: {
    ...mapState('contentHome', ['loading'])
  }
}
</script>
